import { createReducer } from 'redux-create-reducer';

import { buildHydrateEvent, HYDRATE_DUMMY } from '@AIZ-GL/hydrate-dummy';

import {
  UPDATE_CONTACT,
  UPDATE_CREATOR,
  CUSTOMER_DETAILS_FETCHED,
  CUSTOMER_DETAILS_FETCHED_ERROR,
  CUSTOMER_DETAILS_FETCHING,
  GROUP_FETCHED,
  UPDATE_MSISDN,
} from '../actions';

const initialState = {
  company: '',
  email: '',
  name: '',
  phoneNumber: '',
  hasCreator: false,
  sendCreatorNotifications: false,
  communicationPreference: 'text',
  creator: {
    email: '',
    name: '',
    phoneNumber: '',
  },
  msisdn: '',
  subscriberId: '',
  customerDetailsPreloaded: false,
  customerDetailsLoading: false,
  customerDetailsError: '',
  assurantIneligibleRepair: false,
  smsConsent: false,
};

const dummyData = {
  company: 'Blockbuster',
  name: 'Presidente Donald J. Trump',
  email: 'biglyD@wh.gov',
  phoneNumber: '1000000000',
};

const handlers = {
  [HYDRATE_DUMMY]: buildHydrateEvent(dummyData),

  [UPDATE_CONTACT]: (state, action) => ({
    ...state,
    ...action.contact,
  }),
  [UPDATE_CREATOR]: (state, action) => ({
    ...state,
    creatorId: action.creatorId,
  }),

  [CUSTOMER_DETAILS_FETCHING]: state => {
    return { ...state, customerDetailsLoading: true };
  },

  [CUSTOMER_DETAILS_FETCHED]: (
    state,
    {
      email = '',
      name = '',
      phoneNumber = '',
      submittedProductNotSupported = false,
      assurantIneligibleRepair = false,
    }
  ) => ({
    ...state,
    email,
    name,
    phoneNumber,
    creator: {
      ...state.creator,
      email,
      name,
      phoneNumber,
    },
    customerDetailsLoading: false,
    customerDetailsPreloaded: true,
    customerDetailsError: submittedProductNotSupported
      ? 'Submitted product not supported'
      : '',
    assurantIneligibleRepair,
  }),

  [CUSTOMER_DETAILS_FETCHED_ERROR]: (state, { error }) => {
    return {
      ...state,
      customerDetailsLoading: false,
      customerDetailsError: error,
    };
  },
  [GROUP_FETCHED]: (state, { communicationPreference }) => {
    return {
      ...state,
      communicationPreference,
    };
  },
  [UPDATE_MSISDN]: (state, { msisdn }) => {
    return {
      ...state,
      msisdn,
    };
  },
};

export default createReducer(initialState, handlers);
